module.exports = __webpack_public_path__ + "img/banner.b790d1a0.png";